import {ReactElement} from "react";

export default function BlockingPopup(props: { children: ReactElement | ReactElement[] }) {
    const {children} = props;
    return <div className='blocking-popup'>
        <div>{children}</div>
    </div>
}